import { render, staticRenderFns } from "./skuTemp.vue?vue&type=template&id=22b8ff48"
import script from "./skuTemp.vue?vue&type=script&lang=js"
export * from "./skuTemp.vue?vue&type=script&lang=js"
import style0 from "./skuTemp.vue?vue&type=style&index=0&id=22b8ff48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports